export default [
  {
    path: '/portal-cliente/login',
    name: 'portalcliente-login',
    component: () => import('@/app-modulo/documento/login-externo/LoginExterno.vue'),
    meta: {
      resource: 'loginexterno',
      action: 'auditar',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
